// Luật tên khách CHUNG của ERP (user chốt N5): 1–120 ký tự, đếm theo ký tự
// (code point) sau khi gộp khoảng trắng — khớp entity.NormalizeCustomerName ở
// server (server vẫn là nơi chuẩn hoá và kiểm cuối cùng).
export const CUSTOMER_NAME_MAX = 120

export function customerNameLength(name: string): number {
    return [...name.replace(/\s+/g, ' ').trim()].length
}
